(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["onebone-bottoms-size-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bottomsRanges = [
      { min: 30, max: 33, size: "A" },
      { min: 34, max: 37, size: "B" },
      { min: 38, max: 40, size: "C" },
      { min: 41, max: 44, size: "D" },
      { min: 45, max: 49, size: "E" },
      { min: 50, max: 54, size: "F" },
      { min: 55, max: 60, size: "G" },
      { min: 61, max: 65, size: "H" }
    ];

    const topsMatrix = [
      { max: 179, s: ["-2", "-2", "-2", "-1", "-1", "-1", "-1"] },
      { max: 189, s: ["-1", "-1", "-1", "-1", "-1", "-1", "-1"] },
      { max: 199, s: ["0", "0", "-1", "-1", "-1", "-1", "-1"] },
      { max: 209, s: ["0", "0", "0", "0", "0", "0", "0"] },
      { max: 219, s: ["0", "0", "0", "0", "0", "0", "0"] },
      { max: 229, s: ["0", "0", "0", "0", "0", "0", "0"] },
      { max: 239, s: ["0", "0", "0", "0", "0", "0", "0"] },
      { max: 249, s: ["0", "0", "0", "0", "0", "0", "0"] },
      { max: 259, s: ["1", "1", "1", "0", "0", "0", "0"] },
      { max: 269, s: ["1", "1", "1", "1", "1", "1", "1"] },
      { max: 279, s: ["2", "1", "1", "1", "1", "1", "1"] },
      { max: 289, s: ["2", "2", "1", "1", "1", "1", "1"] },
      { max: 299, s: ["2", "2", "1", "1", "1", "1", "1"] },
      { max: 309, s: ["2", "2", "1", "1", "1", "1", "1"] },
      { max: 319, s: ["3", "3", "2", "2", "2", "1", "1"] },
      { max: 329, s: ["3", "3", "2", "2", "2", "2", "2"] },
      { max: 339, s: ["3", "3", "3", "3", "3", "3", "3"] },
      { max: 349, s: ["4", "4", "3", "3", "3", "3", "3"] },
      { max: 359, s: ["4", "4", "3", "3", "3", "3", "3"] },
      { max: 369, s: ["4", "4", "4", "4", "4", "4", "4"] },
      { max: 379, s: ["4", "4", "4", "4", "4", "4", "4"] },
      { max: 389, s: ["5", "5", "4", "4", "4", "3", "3"] },
      { max: 399, s: ["5", "5", "5", "4", "4", "4", "4"] },
      { max: 409, s: ["5", "5", "5", "5", "5", "5", "5"] },
      { max: 419, s: ["5", "5", "5", "5", "5", "5", "5"] },
      { max: 429, s: ["5", "5", "5", "5", "5", "5", "5"] },
      { max: 439, s: ["6", "5", "5", "5", "5", "5", "5"] },
      { max: 449, s: ["6", "6", "6", "6", "6", "6", "6"] },
      { max: 459, s: ["6", "6", "6", "6", "6", "6", "6"] },
      { max: 469, s: ["6", "6", "6", "6", "6", "6", "6"] },
      { max: 479, s: ["6", "6", "6", "6", "6", "6", "6"] },
      { max: 489, s: ["6", "6", "6", "6", "6", "6", "6"] },
      { max: 499, s: ["7", "7", "7", "7", "7", "7", "7"] },
      { max: Infinity, s: ["7", "7", "7", "7", "7", "7", "7"] }
    ];

    const heightColumn = height => height <= 68 ? 0 : height <= 71 ? 1 : height <= 74 ? 2 : height <= 77 ? 3 : height <= 80 ? 4 : height <= 83 ? 5 : 6;
    const formatHeight = inches => `${Math.floor(inches / 12)}'${inches % 12}"`;

    const init = root => {
      root.querySelectorAll("[data-ob-size-tool]").forEach(tool => {
        if (tool.dataset.ready) return;
        tool.dataset.ready = "true";

        const tabs = [...tool.querySelectorAll("[data-ob-size-tab]")];
        const panels = [...tool.querySelectorAll("[data-ob-size-panel]")];
        const activate = type => {
          tabs.forEach(tab => {
            const active = tab.dataset.obSizeTab === type;
            tab.classList.toggle("is-active", active);
            tab.setAttribute("aria-selected", String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => {
            panel.hidden = panel.dataset.obSizePanel !== type;
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener("click", () => activate(tab.dataset.obSizeTab));
          tab.addEventListener("keydown", event => {
            if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
            if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === "Home") nextIndex = 0;
            if (event.key === "End") nextIndex = tabs.length - 1;
            tabs[nextIndex].focus();
            activate(tabs[nextIndex].dataset.obSizeTab);
          });
        });

        const height = tool.querySelector(".js-ob-tops-height");
        const weight = tool.querySelector(".js-ob-tops-weight");
        const heightValue = tool.querySelector(".js-ob-tops-height-value");
        const weightValue = tool.querySelector(".js-ob-tops-weight-value");
        const topsSize = tool.querySelector(".js-ob-tops-size");
        const weightUnit = tool.dataset.weightUnit || "lb";
        const updateTops = () => {
          const inches = Number(height.value);
          const pounds = Number(weight.value);
          const row = topsMatrix.find(range => pounds <= range.max) || topsMatrix[topsMatrix.length - 1];
          heightValue.textContent = formatHeight(inches);
          weightValue.textContent = pounds >= 500 ? `500+ ${weightUnit}` : `${pounds} ${weightUnit}`;
          topsSize.textContent = row.s[heightColumn(inches)];
        };
        height.addEventListener("input", updateTops);
        weight.addEventListener("input", updateTops);
        updateTops();

        const waist = tool.querySelector(".js-ob-bottoms-waist");
        const waistValue = tool.querySelector(".js-ob-bottoms-waist-value");
        const bottomsSize = tool.querySelector(".js-ob-bottoms-size");
        const rangeValue = tool.querySelector(".js-ob-bottoms-range");
        const waistUnit = tool.dataset.waistUnit || "in";
        const updateBottoms = () => {
          const value = Number(waist.value);
          const match = bottomsRanges.find(range => value >= range.min && value <= range.max) || bottomsRanges[0];
          waistValue.textContent = `${value} ${waistUnit}`;
          bottomsSize.textContent = match.size;
          rangeValue.textContent = `${match.min}–${match.max}`;
        };
        waist.addEventListener("input", updateBottoms);
        updateBottoms();
      });
    };

    init(document);
    document.addEventListener("shopify:section:load", event => init(event.target));
    document.addEventListener("shopify:block:select", event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-category-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOneBoneCategorySections(container = document) {
      const sections = container.querySelectorAll('[data-ob-category-section]');

      sections.forEach((section) => {
        if (section.dataset.obInitialized === 'true') return;

        const rail = section.querySelector('[data-ob-category-rail]');
        const cards = Array.from(section.querySelectorAll('[data-ob-category-card]'));
        const progressItems = Array.from(section.querySelectorAll('[data-ob-progress-item]'));
        const enableHover = section.dataset.hoverExpand === 'true';

        if (!rail || cards.length === 0) return;

        section.dataset.obInitialized = 'true';

        function setActiveCard(activeCard) {
          cards.forEach((card, index) => {
            const isActive = card === activeCard;
            card.classList.toggle('is-active', isActive);
            card.setAttribute('aria-current', isActive ? 'true' : 'false');

            if (progressItems[index]) {
              progressItems[index].classList.toggle('is-active', isActive);
            }
          });
        }

        cards.forEach((card) => {
          if (enableHover) {
            card.addEventListener('pointerenter', () => setActiveCard(card));
          }

          card.addEventListener('focusin', () => setActiveCard(card));
          card.addEventListener('click', (event) => {
            if (!event.target.closest('a')) setActiveCard(card);
          });
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              setActiveCard(card);
            }
          });
        });

        let scrollFrame = null;

        rail.addEventListener('scroll', () => {
          if (!window.matchMedia('(max-width: 900px)').matches) return;
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

          scrollFrame = window.requestAnimationFrame(() => {
            const railLeft = rail.getBoundingClientRect().left;
            let activeCard = cards[0];
            let smallestDistance = Number.POSITIVE_INFINITY;

            cards.forEach((card) => {
              const distance = Math.abs(card.getBoundingClientRect().left - railLeft);
              if (distance < smallestDistance) {
                smallestDistance = distance;
                activeCard = card;
              }
            });

            setActiveCard(activeCard);
          });
        }, { passive: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOneBoneCategorySections());
    } else {
      initOneBoneCategorySections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOneBoneCategorySections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-category-micro-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOBMicroNav(container = document) {
      const sections = container.querySelectorAll('[data-ob-micro-nav]');

      sections.forEach((section) => {
        if (section.dataset.obMicroInitialized === 'true') return;

        const rail = section.querySelector('[data-ob-micro-rail]');
        const items = Array.from(section.querySelectorAll('[data-ob-micro-item]'));
        const prev = section.querySelector('[data-ob-micro-prev]');
        const next = section.querySelector('[data-ob-micro-next]');

        if (!rail || items.length === 0) return;

        section.dataset.obMicroInitialized = 'true';

        function setActiveItem(activeItem) {
          items.forEach((item) => {
            const isActive = item === activeItem;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'page' : 'false');
          });
        }

        function scrollRail(direction) {
          const amount = Math.max(rail.clientWidth * 0.72, 220);
          rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
        }

        items.forEach((item) => {
          item.addEventListener('click', () => setActiveItem(item));
        });

        if (prev) {
          prev.addEventListener('click', () => scrollRail(-1));
        }

        if (next) {
          next.addEventListener('click', () => scrollRail(1));
        }

        const currentPath = window.location.pathname.replace(/\/$/, '');
        const currentUrl = window.location.href.replace(/\/$/, '');
        const matchedItem = items.find((item) => {
          const itemHref = item.href.replace(/\/$/, '');
          const itemPath = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '');
          return itemHref === currentUrl || itemPath === currentPath;
        });

        if (matchedItem) {
          setActiveItem(matchedItem);
          matchedItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOBMicroNav());
    } else {
      initOBMicroNav();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOBMicroNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-featured-product"] && !Shopify.designMode) return;
  try {
    
  (()=>{const roots=document.querySelectorAll('[data-obfp-section]');roots.forEach(root=>{if(root.dataset.obfpReady)return;root.dataset.obfpReady='true';const variantsNode=root.querySelector('[data-obfp-variants]'),form=root.querySelector('[data-obfp-form]');if(!variantsNode||!form)return;const variants=JSON.parse(variantsNode.textContent),variantInput=form.querySelector('[data-obfp-variant-id]'),inputs=[...form.querySelectorAll('[data-obfp-option-input]')],price=root.querySelector('[data-obfp-price]'),compare=root.querySelector('[data-obfp-compare]'),button=root.querySelector('[data-obfp-submit]'),buttonLabel=root.querySelector('[data-obfp-submit-label]'),buttonPrice=root.querySelector('[data-obfp-button-price]'),message=root.querySelector('[data-obfp-message]'),productLink=root.querySelector('[data-obfp-product-link]'),sticky=root.querySelector('[data-obfp-sticky]'),stickyButton=root.querySelector('[data-obfp-sticky-button]'),stickyLabel=root.querySelector('[data-obfp-sticky-label]'),stickyPrice=root.querySelector('[data-obfp-sticky-price]'),stickyVariant=root.querySelector('[data-obfp-sticky-variant]'),viewport=root.querySelector('[data-obfp-viewport]'),slides=[...root.querySelectorAll('[data-obfp-slide]')],thumbs=[...root.querySelectorAll('[data-obfp-thumbnail]')],current=root.querySelector('[data-obfp-current]');let activeVariant=variants.find(v=>String(v.id)===String(variantInput.value))||variants[0],activeSlide=0,buttonInView=true;const labels={add:root.dataset.addLabel,sold:root.dataset.soldLabel,adding:root.dataset.addingLabel,added:root.dataset.addedLabel,error:root.dataset.errorLabel,fitSelected:root.dataset.fitSelected,fitUnavailable:root.dataset.fitUnavailable,fitRecommendation:root.dataset.fitRecommendation},withSize=(template,size)=>template.replace('[size]',size),selectedOptions=()=>{const groups=[...form.querySelectorAll('[data-obfp-option]')];return groups.map(group=>group.querySelector('[data-obfp-option-input]:checked')?.value).filter(value=>value!==undefined)},findVariant=()=>{const selected=selectedOptions();return variants.find(variant=>variant.options.length===selected.length&&variant.options.every((value,index)=>value===selected[index]))},showSlide=index=>{if(!viewport||!slides.length)return;activeSlide=Math.max(0,Math.min(index,slides.length-1));slides[activeSlide].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===activeSlide);thumb.setAttribute('aria-pressed',i===activeSlide?'true':'false')});if(current)current.textContent=String(activeSlide+1)},showMedia=id=>{if(!id)return;const index=slides.findIndex(slide=>String(slide.dataset.mediaId)===String(id));if(index>=0)showSlide(index)},setAvailability=()=>{const selected=selectedOptions();inputs.forEach(input=>{const position=Number(input.dataset.optionPosition)-1,candidate=[...selected];candidate[position]=input.value;const available=variants.some(variant=>variant.available&&variant.options.every((value,index)=>candidate[index]===undefined||value===candidate[index]));input.disabled=!available;input.closest('label')?.classList.toggle('is-unavailable',!available)})},update=()=>{const variant=findVariant();activeVariant=variant||null;setAvailability();if(!variant){variantInput.value='';button.disabled=true;if(stickyButton)stickyButton.disabled=true;message.textContent=labels.sold;return}variantInput.value=variant.id;price.textContent=variant.price_formatted;price.classList.toggle('is-sale',variant.compare_at_price>variant.price);if(variant.compare_at_price>variant.price){compare.textContent=variant.compare_at_price_formatted;compare.classList.remove('is-hidden')}else{compare.textContent='';compare.classList.add('is-hidden')}const available=variant.available;button.disabled=!available;buttonLabel.textContent=available?labels.add:labels.sold;buttonPrice.textContent=available?variant.price_formatted:'';if(stickyButton)stickyButton.disabled=!available;if(stickyLabel)stickyLabel.textContent=available?labels.add:labels.sold;if(stickyPrice)stickyPrice.textContent=available?variant.price_formatted:'';if(stickyVariant)stickyVariant.textContent=variant.title;if(productLink)productLink.href=`${productLink.href.split('?')[0]}?variant=${variant.id}`;message.textContent='';showMedia(variant.featured_media_id)};inputs.forEach(input=>input.addEventListener('change',update));thumbs.forEach(thumb=>thumb.addEventListener('click',()=>showSlide(Number(thumb.dataset.obfpThumbnail))));root.querySelector('[data-obfp-previous]')?.addEventListener('click',()=>showSlide(activeSlide-1));root.querySelector('[data-obfp-next]')?.addEventListener('click',()=>showSlide(activeSlide+1));if(viewport){let ticking=false;viewport.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{const width=viewport.clientWidth||1,position=Math.round(viewport.scrollLeft/width);if(position!==activeSlide){activeSlide=position;thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===activeSlide);thumb.setAttribute('aria-pressed',i===activeSlide?'true':'false')});if(current)current.textContent=String(activeSlide+1)}ticking=false})},{passive:true})}const emailCodeLink=root.querySelector('[data-obfp-email-code]');emailCodeLink?.addEventListener('click',event=>{event.preventDefault();window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm','W5sKSn'])});const fit=root.querySelector('[data-obfp-fit]'),openFit=root.querySelector('[data-obfp-open-fit]'),height=root.querySelector('[data-obfp-height]'),weight=root.querySelector('[data-obfp-weight]'),heightOutput=root.querySelector('[data-obfp-height-output]'),weightOutput=root.querySelector('[data-obfp-weight-output]'),fitSize=root.querySelector('[data-obfp-fit-size]'),fitMessage=root.querySelector('[data-obfp-fit-message]'),matrix=[{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}],heightColumn=value=>value<=68?0:value<=71?1:value<=74?2:value<=77?3:value<=80?4:value<=83?5:6,normalize=value=>String(value).toLowerCase().replace(/^size\s*/,'').trim(),recommend=()=>{if(!height||!weight)return;const inches=Number(height.value),pounds=Number(weight.value),row=matrix.find(range=>pounds<=range.max)||matrix[matrix.length-1],size=row.s[heightColumn(inches)];heightOutput.textContent=`${Math.floor(inches/12)}'${inches%12}\"`;weightOutput.textContent=pounds>=500?'500 lb+':`${pounds} lb`;fitSize.textContent=size;const sizeGroup=[...form.querySelectorAll('[data-obfp-option]')].find(group=>group.dataset.optionName.toLowerCase().includes('size'));const sizeInput=sizeGroup?[...sizeGroup.querySelectorAll('[data-obfp-option-input]')].find(input=>normalize(input.value)===normalize(size)):null;if(sizeInput&&!sizeInput.disabled){if(!sizeInput.checked){sizeInput.checked=true;sizeInput.dispatchEvent(new Event('change',{bubbles:true}))}fitMessage.textContent=withSize(labels.fitSelected,size)}else if(sizeInput){fitMessage.textContent=withSize(labels.fitUnavailable,size)}else{fitMessage.textContent=withSize(labels.fitRecommendation,size)}};openFit?.addEventListener('click',()=>{fit.open=!fit.open;openFit.setAttribute('aria-expanded',fit.open?'true':'false');if(fit.open)fit.scrollIntoView({behavior:'smooth',block:'nearest'})});fit?.addEventListener('toggle',()=>openFit?.setAttribute('aria-expanded',fit.open?'true':'false'));height?.addEventListener('input',recommend);weight?.addEventListener('input',recommend);recommend();form.addEventListener('submit',async event=>{if(!activeVariant||!activeVariant.available){event.preventDefault();message.textContent=labels.sold;form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();return}if(!window.fetch)return;event.preventDefault();button.disabled=true;message.textContent=labels.adding;const data=new FormData(form);try{const helper=window.Alpine?.store?.('xCartHelper');if(helper){data.append('sections',helper.getSectionsToRender().map(section=>section.id));data.append('sections_url',window.location.pathname)}const endpoint=window.Eurus?.cart_add_url||`${window.Shopify?.routes?.root||'/'}cart/add.js`,response=await fetch(endpoint,{method:'POST',headers:{Accept:'application/javascript','X-Requested-With':'XMLHttpRequest'},body:data}),result=await response.json();if(!response.ok||result.status===422)throw new Error(result.description||labels.error);if(helper&&result.sections)helper.reRenderSections(result.sections);const notice=window.Alpine?.store?.('xCartNoti');if(notice?.enable)notice.setItem(result);const miniCart=window.Alpine?.store?.('xMiniCart');if(miniCart&&!notice?.enable)miniCart.openCart();document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));message.textContent=labels.added}catch(error){message.textContent=error.message||labels.error}finally{button.disabled=!activeVariant?.available}});stickyButton?.addEventListener('click',()=>{if(button.disabled){form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();form.scrollIntoView({behavior:'smooth',block:'center'});return}button.click()});if(sticky&&button){const observer=new IntersectionObserver(entries=>{buttonInView=entries[0].isIntersecting;updateSticky()},{threshold:.1}),updateSticky=()=>{const rect=root.getBoundingClientRect(),sectionVisible=rect.top<window.innerHeight&&rect.bottom>0,show=sectionVisible&&!buttonInView&&rect.top<0;sticky.classList.toggle('is-visible',show);sticky.setAttribute('aria-hidden',show?'false':'true')};observer.observe(button);window.addEventListener('scroll',updateSticky,{passive:true})}update()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-new-customer"] && !Shopify.designMode) return;
  try {
    
(()=>{const f=i=>`${Math.floor(i/12)}'${i%12}"`,matrix=[{max:179,s:["-2","-2","-2","-1","-1","-1","-1"]},{max:189,s:["-1","-1","-1","-1","-1","-1","-1"]},{max:199,s:["0","0","-1","-1","-1","-1","-1"]},{max:209,s:["0","0","0","0","0","0","0"]},{max:219,s:["0","0","0","0","0","0","0"]},{max:229,s:["0","0","0","0","0","0","0"]},{max:239,s:["0","0","0","0","0","0","0"]},{max:249,s:["0","0","0","0","0","0","0"]},{max:259,s:["1","1","1","0","0","0","0"]},{max:269,s:["1","1","1","1","1","1","1"]},{max:279,s:["2","1","1","1","1","1","1"]},{max:289,s:["2","2","1","1","1","1","1"]},{max:299,s:["2","2","1","1","1","1","1"]},{max:309,s:["2","2","1","1","1","1","1"]},{max:319,s:["3","3","2","2","2","1","1"]},{max:329,s:["3","3","2","2","2","2","2"]},{max:339,s:["3","3","3","3","3","3","3"]},{max:349,s:["4","4","3","3","3","3","3"]},{max:359,s:["4","4","3","3","3","3","3"]},{max:369,s:["4","4","4","4","4","4","4"]},{max:379,s:["4","4","4","4","4","4","4"]},{max:389,s:["5","5","4","4","4","3","3"]},{max:399,s:["5","5","5","4","4","4","4"]},{max:409,s:["5","5","5","5","5","5","5"]},{max:419,s:["5","5","5","5","5","5","5"]},{max:429,s:["5","5","5","5","5","5","5"]},{max:439,s:["6","5","5","5","5","5","5"]},{max:449,s:["6","6","6","6","6","6","6"]},{max:459,s:["6","6","6","6","6","6","6"]},{max:469,s:["6","6","6","6","6","6","6"]},{max:479,s:["6","6","6","6","6","6","6"]},{max:489,s:["6","6","6","6","6","6","6"]},{max:499,s:["7","7","7","7","7","7","7"]},{max:Infinity,s:["7","7","7","7","7","7","7"]}],heightColumn=h=>h<=68?0:h<=71?1:h<=74?2:h<=77?3:h<=80?4:h<=83?5:6;document.querySelectorAll("[data-ob-fit-tool]").forEach(tool=>{if(tool.dataset.ready)return;tool.dataset.ready="true";const h=tool.querySelector(".js-ob-height"),w=tool.querySelector(".js-ob-weight"),hv=tool.querySelector(".js-ob-height-value"),wv=tool.querySelector(".js-ob-weight-value"),s=tool.querySelector(".js-ob-shirt-size"),n=tool.querySelector(".js-ob-fit-note"),unit=tool.dataset.weightUnit||"lb",notes={"-2":tool.getAttribute("data-note-size-minus-2"),"-1":tool.getAttribute("data-note-size-minus-1"),"0":tool.getAttribute("data-note-size-0"),"1":tool.getAttribute("data-note-size-1"),"2":tool.getAttribute("data-note-size-2"),"3":tool.getAttribute("data-note-size-3"),"4":tool.getAttribute("data-note-size-4"),"5":tool.getAttribute("data-note-size-5"),"6":tool.getAttribute("data-note-size-6"),"7":tool.getAttribute("data-note-size-7")},u=()=>{const ih=Number(h.value),iw=Number(w.value),row=matrix.find(r=>iw<=r.max)||matrix[matrix.length-1],size=row.s[heightColumn(ih)];hv.textContent=f(ih);wv.textContent=iw>=500?`500${unit}+`:`${iw} ${unit}`;s.textContent=size;n.textContent=notes[size]||notes["2"]};h.addEventListener("input",u);w.addEventListener("input",u);u()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-size-calculator"] && !Shopify.designMode) return;
  try {
    
(()=>{if(window.__oneBoneSizeCalculatorReady)return;window.__oneBoneSizeCalculatorReady=true;const formatHeight=i=>`${Math.floor(i/12)}'${i%12}"`,matrix=[{max:179,s:["-2","-2","-2","-1","-1","-1","-1"]},{max:189,s:["-1","-1","-1","-1","-1","-1","-1"]},{max:199,s:["0","0","-1","-1","-1","-1","-1"]},{max:209,s:["0","0","0","0","0","0","0"]},{max:219,s:["0","0","0","0","0","0","0"]},{max:229,s:["0","0","0","0","0","0","0"]},{max:239,s:["0","0","0","0","0","0","0"]},{max:249,s:["0","0","0","0","0","0","0"]},{max:259,s:["1","1","1","0","0","0","0"]},{max:269,s:["1","1","1","1","1","1","1"]},{max:279,s:["2","1","1","1","1","1","1"]},{max:289,s:["2","2","1","1","1","1","1"]},{max:299,s:["2","2","1","1","1","1","1"]},{max:309,s:["2","2","1","1","1","1","1"]},{max:319,s:["3","3","2","2","2","1","1"]},{max:329,s:["3","3","2","2","2","2","2"]},{max:339,s:["3","3","3","3","3","3","3"]},{max:349,s:["4","4","3","3","3","3","3"]},{max:359,s:["4","4","3","3","3","3","3"]},{max:369,s:["4","4","4","4","4","4","4"]},{max:379,s:["4","4","4","4","4","4","4"]},{max:389,s:["5","5","4","4","4","3","3"]},{max:399,s:["5","5","5","4","4","4","4"]},{max:409,s:["5","5","5","5","5","5","5"]},{max:419,s:["5","5","5","5","5","5","5"]},{max:429,s:["5","5","5","5","5","5","5"]},{max:439,s:["6","5","5","5","5","5","5"]},{max:449,s:["6","6","6","6","6","6","6"]},{max:459,s:["6","6","6","6","6","6","6"]},{max:469,s:["6","6","6","6","6","6","6"]},{max:479,s:["6","6","6","6","6","6","6"]},{max:489,s:["6","6","6","6","6","6","6"]},{max:499,s:["7","7","7","7","7","7","7"]},{max:Infinity,s:["7","7","7","7","7","7","7"]}],heightColumn=h=>h<=68?0:h<=71?1:h<=74?2:h<=77?3:h<=80?4:h<=83?5:6,init=root=>{root.querySelectorAll("[data-ob-size-tool]").forEach(tool=>{if(tool.dataset.ready)return;tool.dataset.ready="true";const height=tool.querySelector(".js-ob-size-height"),weight=tool.querySelector(".js-ob-size-weight"),heightValue=tool.querySelector(".js-ob-size-height-value"),weightValue=tool.querySelector(".js-ob-size-weight-value"),shirt=tool.querySelector(".js-ob-size-shirt"),note=tool.querySelector(".js-ob-size-note"),unit=tool.dataset.weightUnit||"lb",notes={"-2":tool.getAttribute("data-note-size-minus-2"),"-1":tool.getAttribute("data-note-size-minus-1"),"0":tool.getAttribute("data-note-size-0"),"1":tool.getAttribute("data-note-size-1"),"2":tool.getAttribute("data-note-size-2"),"3":tool.getAttribute("data-note-size-3"),"4":tool.getAttribute("data-note-size-4"),"5":tool.getAttribute("data-note-size-5"),"6":tool.getAttribute("data-note-size-6"),"7":tool.getAttribute("data-note-size-7")},update=()=>{const inches=Number(height.value),pounds=Number(weight.value),row=matrix.find(range=>pounds<=range.max)||matrix[matrix.length-1],size=row.s[heightColumn(inches)];heightValue.textContent=formatHeight(inches);weightValue.textContent=pounds>=500?`500${unit}+`:`${pounds} ${unit}`;shirt.textContent=size;if(note)note.textContent=notes[size]||notes["2"]};height.addEventListener("input",update);weight.addEventListener("input",update);update()})};init(document);document.addEventListener("shopify:section:load",event=>init(event.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-starter-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.obStarterReady) return;

      root.dataset.obStarterReady = 'true';

      root.querySelectorAll('[data-ob-starter-card]').forEach(card => {
        const image = card.querySelector('.ob-starter__image');
        const media = card.querySelector('.ob-starter__media');
        const title = card.querySelector('[data-ob-starter-title]');
        const links = [...card.querySelectorAll('[data-ob-starter-link]')];
        const price = card.querySelector('[data-ob-starter-price]');
        const compare = card.querySelector('[data-ob-starter-compare]');
        const status = card.querySelector('[data-ob-starter-status]');
        const dot = card.querySelector('.ob-starter__status-dot');
        const badge = card.querySelector('[data-ob-starter-badge]');
        const quick = card.querySelector('[data-ob-starter-quick-view]');
        const quickLabel = card.querySelector('[data-ob-starter-quick-label]');
        const variant = card.querySelector('[data-ob-starter-variant]');
        const swatches = [...card.querySelectorAll('[data-ob-starter-swatch]')];

        swatches.forEach(swatch => {
          swatch.addEventListener('click', () => {
            const data = swatch.dataset;
            const available = data.available === 'true';

            swatches.forEach(item => {
              item.classList.toggle('is-active', item === swatch);
              item.setAttribute(
                'aria-pressed',
                item === swatch ? 'true' : 'false'
              );
            });

            if (image && data.image) {
              image.src = data.image;
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
              image.alt = data.title || '';
            }

            if (media) {
              media.href = data.detailUrl;
              media.setAttribute('aria-label', data.title || '');
            }

            links.forEach(link => {
              link.href = data.detailUrl;
            });

            if (title) {
              title.textContent = data.title;
            }

            if (price) {
              price.textContent = data.price;
              price.classList.toggle('is-sale', Boolean(data.compare));
            }

            if (compare) {
              compare.textContent = data.compare;
              compare.hidden = !data.compare;
            }

            if (status) {
              status.textContent = available
                ? card.dataset.availableLabel
                : card.dataset.unavailableLabel;
            }

            if (dot) {
              dot.classList.toggle('is-unavailable', !available);
            }

            if (badge) {
              badge.hidden = available;
            }

            if (quick) {
              quick.dataset.productUrl = data.productUrl;
              quick.disabled = !available;
              quick.setAttribute(
                'aria-label',
                (card.dataset.chooseFor || '').replace(
                  '[product]',
                  data.title || ''
                )
              );
            }

            if (quickLabel) {
              quickLabel.textContent = available
                ? card.dataset.chooseLabel
                : card.dataset.soldLabel;
            }

            if (variant) {
              variant.textContent = data.variantId || '';
            }
          });
        });
      });
    };

    document.querySelectorAll('.ob-starter').forEach(init);

    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('.ob-starter').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
